export const APP_NAME = 'Showliner';
export const APP_DESCRIPTION = 'Event booking, scheduling, and live interactivity for venues and performers';
export const LIVE_SERVICE_NAME = 'Showliner Live';
